import React from 'react';
import { FormattedMessage } from 'react-intl';

import Styled from 'styled';

import TextInputView from 'four-nets/ui/text-input-view';
import FieldWithLabelView from 'four-nets/ui/form/field-with-label-view';

import defaultStyles from './field-view.scss';

export interface Props {
    from?: number | string;
    to?: number | string;
    styles: typeof defaultStyles;
    setFrom: (event: KeyboardEvent) => void;
    setTo: (event: KeyboardEvent) => void;
}

class FieldPriceView extends React.Component<Props> {
    static defaultProps = {
        from: 0,
        to: '',
    };

    render() {
        const { styles } = this.props;

        return (
            <div className={styles.inlineWrapper}>
                <FieldWithLabelView
                    mini={true}
                    label={<FormattedMessage id='BAZAAR_FILTER_FROM_TITLE' />}
                    field={
                        <TextInputView
                            type='number'
                            step='10'
                            min='0'
                            max='50000'
                            onChange={this.props.setFrom}
                            value={this.props.from}
                        />
                    }
                />
                <FieldWithLabelView
                    mini={true}
                    label={<FormattedMessage id='BAZAAR_FILTER_TO_TITLE' />}
                    field={
                        <TextInputView
                            type='number'
                            step='10'
                            min='0'
                            max='500000'
                            onChange={this.props.setTo}
                            value={this.props.to}
                        />
                    }
                />
            </div>
        );
    }
}

export default Styled(defaultStyles)(FieldPriceView);
